<template lang="pug">
  Modal(ref="dlg" title="Create Group" closeable="true")
    form(role="form" @submit.prevent="save")
      .create-group-modal-body.ssp-form-horizontal
        .form-group
          label.ic-label Name
          .ic-control
            input.form-control.name-input.focus(type="text" v-model="name")
        .form-group
          label.ic-label Type
          .ic-control
            GroupTypeSelector(v-model="representation")
        .text-right
          button.btn.btn-default(type="button" @click="$refs.dlg.cancel()") Cancel
          button.ml10.btn.btn-primary.create-button(type="submit" :disabled="!isValid") Create
    div(slot="footer")
</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import GroupTypeSelector from '@/components/ssp/GroupTypeSelector'
import Modal from '@/components/common/Modal'

export default {
  data() {
    return {
      name: null,
      representation: null,
      createAsChild: false
    }
  },
  methods: {
    save() {
      const req = {
        representation: this.representation,
        name: this.name
      }
      if (this.createAsChild === true) {
        req.parentId = this.$route.params.id
      }

      const call = this.createAsChild ? Security.createGroup(req) : Security.createGroup(req)
      const action = this.createAsChild ? 'created' : 'added as child group'
      call
        .then((resp) => {
          miniToastr.success(`Group was ${action}`)
          this.$emit('success', resp.data)
          this.$refs.dlg.close()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    open() {
      if (this.$route.params.id) {
        this.createAsChild = true
      }
      this.$refs.dlg.open()
    }
  },
  computed: {
    isValid() {
      return this.name
    }
  },
  components: {
    GroupTypeSelector,
    Modal
  }
}
</script>

<style lang="scss">
.create-group-modal-body {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/management/group/CreateGroupModal.vue